/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  horizontalSplitPanel: Item<'HorizontalSplitPanel'>;
  box: Item<'Box'>;
  chooseIconImageCropper: Item<'ImageCropper'>;
} = {
  box: {
    children: ['chooseIconImageCropper'],
    itemId: 'box',
    parent: 'horizontalSplitPanel',
    props: { boxWidth: '500px', maxWidth: '500px' },
    type: 'Box',
  },
  chooseIconImageCropper: {
    children: [],
    itemId: 'chooseIconImageCropper',
    parent: 'box',
    props: {
      viewAttribute: 'fileUid',
    },
    type: 'ImageCropper',
  },
  dataStoreReference: {
    children: ['horizontalSplitPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'test',
    },
    type: 'DataStoreReference',
  },
  horizontalSplitPanel: {
    children: ['box'],
    itemId: 'horizontalSplitPanel',
    parent: 'dataStoreReference',
    props: {
      fixedHeight: 800,
    },
    type: 'HorizontalSplitPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      dataSource: 'test',
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};

export const helpRenders: ComponentSample<'ImageCropper'>[] = [
  {
    title: 'Image Cropper',
    description: 'Image Cropper',
    page,
    exampleId: 'eg-01H1BZ7ENCRWE0GVW330PG9FXE',
    clearParentChildren: true,
    height: 280,
    visibleProps: ['viewAttribute'],
    item: {
      type: 'ImageCropper',
      props: {
        viewAttribute: 'fileUid',
      },
      itemId: 'chooseIconImageCropper',
      parent: 'box',
      children: [],
    },
  },
];
